import React from "react";
import { ShowSidePanel } from "../Show/ShowSidePanel";
import { FlightSidePanel } from "../Flight/FlightSidePanel";
import { TrainSidePanel } from "../Train/TrainSidePanel";
import { GroundTransportSidePanel } from "../GroundTransport/GroundSidePanel";
import { ExternalEventSidePanel } from "../ExternalEvent/ExternalEventSidePanel";

interface AppointmentSidePanelProps {
  appointment: server.dto.AppointmentForPlanner;
  children: JSX.Element;
  onChange: () => void
}

export const AppointmentSidePanel = (props: AppointmentSidePanelProps) => {
  const { appointment, children } = props;

  switch (appointment.type.value) {
    case "externalCalendar":
      return <ExternalEventSidePanel externalEventId={appointment.id} trigger={children} />;
    case "show":
      return <ShowSidePanel canEdit onChange={props.onChange} showId={appointment.id} trigger={children} />;
    case "flight":
      return <FlightSidePanel flightSegmentId={appointment.id} trigger={children} />;
    case "train":
      return <TrainSidePanel trainSegmentId={appointment.id} trigger={children} />;
    case "groundTransport":
      return <GroundTransportSidePanel onChange={props.onChange} groundTransportId={appointment.id} trigger={children} />;
    default:
      return children;
  }
};

interface AppointmentSidePanelPlannerProps {
  appointment: server.dto.PlannerAppointment;
  onChange: () => void;
  children: JSX.Element;
}

export const AppointmentSidePanelPlanner = (props: AppointmentSidePanelPlannerProps) => {
  const { appointment, children, onChange } = props;

  switch (appointment.type.value) {
    case "externalCalendar":
      return <ExternalEventSidePanel externalEventId={appointment.externalEventId} trigger={children} />;
    case "show":
      return <ShowSidePanel canEdit onChange={onChange} showId={appointment.showId} trigger={children} />;
    case "flight":
      return <FlightSidePanel flightSegmentId={appointment.flightSegmentId} trigger={children} />;
    case "train":
      return <TrainSidePanel trainSegmentId={appointment.trainSegmentId} trigger={children} />;
    case "groundTransport":
      return <GroundTransportSidePanel onChange={props.onChange} groundTransportId={appointment.groundTransportId} trigger={children} />;
    default:
      return children;
  }
};